import HeaderLoginUi from 'core/components/header_login_ui'
import * as Header from 'quick-win/nav'

Header.initialize()
if (document.querySelector('nav.wz-nav')) {
  new HeaderLoginUi(document.querySelector('nav.wz-nav'))
}
if (document.querySelector('nav.wz-menu')) {
  new HeaderLoginUi(document.querySelector('nav.wz-menu'))
}
